/* ============
 * Getters for the global module
 * ============
 *
 * The getters that are available on the
 * global module.
 */
export const members = (state) => {
  return state.members
}
export const total = (state) => {
  return state.total
}
export const offset = (state) => {
  return state.offset
}
export const max = (state) => {
  return state.max
}
export const getMemberById = (state) => (id) => {
  return state.members.find(member => member.id === id)
}
export const sort = (state) => {
  return state.sort
}
export const order = (state) => {
  return state.order
}
export default {
  members,
  total,
  offset,
  max,
  getMemberById,
  sort,
  order,
}
